import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/**
 * @file useMark 获取Mark的信息
 */
import { getDefaultElementOffset } from '@tencent/glue-util-boundary';
import { useDrag } from '@tencent/glue-react-drag';
import { useRefGetter, useUpdate } from '@tencent/glue-react-use';
import { useCallback, useEffect, useRef } from 'react';
import { usePoint } from './usePoint';
export function useDragger(name, draggable) {
  var update = useUpdate();
  var point = usePoint(name);
  var region = point.getRegion();
  var value = point.getPointValue();
  var offset = point.getOffset();
  var selected = region.isValueSelected(value);
  var startOffsetRef = useRef(getDefaultElementOffset());
  var offsetGetter = useRefGetter(offset);
  var onDragStart = useCallback(function () {
    startOffsetRef.current = offsetGetter();
    point.setDragging(true);
  }, []);
  var onDragging = useCallback(function (e) {
    var deltaX = e.currentMousePos.clientX - e.startMousePos.clientX;
    var deltaY = e.currentMousePos.clientY - e.startMousePos.clientY;
    var x = deltaX + startOffsetRef.current.x;
    var y = deltaY + startOffsetRef.current.y;
    point.updateRealOffset(startOffsetRef.current, {
      x: x,
      y: y
    });
  }, []);
  var onDragEnd = useCallback(function (e) {
    var deltaX = e.currentMousePos.clientX - e.startMousePos.clientX;
    var deltaY = e.currentMousePos.clientY - e.startMousePos.clientY;
    var x = deltaX + startOffsetRef.current.x;
    var y = deltaY + startOffsetRef.current.y;
    point.setDragging(false);
    point.updateRealOffset(startOffsetRef.current, {
      x: x,
      y: y
    });
    startOffsetRef.current = getDefaultElementOffset();
  }, []);

  var _useDrag = useDrag({
    draggable: draggable,
    data: null,
    onDragEnd: onDragEnd,
    onDragging: onDragging,
    onDragStart: onDragStart
  }),
      _useDrag2 = _slicedToArray(_useDrag, 1),
      ref = _useDrag2[0];

  useEffect(function () {
    point.addListener('repaint', update);
    return function () {
      return point.removeListener('repaint', update);
    };
  }, [point]);
  return [ref, {
    offset: offset,
    selected: selected,
    precision: point.getOffsetPrecisionValue(),
    dragging: point.getDragging()
  }];
}